import ElasticProcessor from '@lib/processors/elastic-processor'
import store from '~/state/store.js'


const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'id',
    label: 'Role ID',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'name',
    label: 'Role Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'productId',
    label: 'Product Name',
    type: 'string',
    icon: 'el-icon-document',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    type: 'string',
    icon: 'el-icon-date',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY hh:mm A'],
    },
    width: 100,
  },
  {
    name: 'id',
    label: 'Role ID',
    icon: 'el-icon-document',
  },
  {
    name: 'name',
    label: 'Role Name',
    icon: 'el-icon-document',
  },
  {
    name: 'productId',
    label: 'Product Id',
    icon: 'el-icon-document',
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'roles',
    headers: {
      'Provider-Id': store.getters['me/meProviderId'] || 'null',
    },
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'roles',
})
